export const JOIN_SKELETON = 'join-skeleton';
